import { render, staticRenderFns } from "./ContentPreview.vue?vue&type=template&id=5c75480a&scoped=true&"
import script from "./ContentPreview.vue?vue&type=script&lang=ts&"
export * from "./ContentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPreview.vue?vue&type=style&index=0&id=5c75480a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75480a",
  null
  
)

export default component.exports